/* @flow */
import {
  BASE_YEAR,
  LUNAR_CONSTANTS,
  HOUR_SELECTION,
  LUNAR_HOURS,
  STEMS,
  BRANCHES,
} from './constants'
import {
  isLeapYear,
  getDaysInSolarYear,
  getSolarMonthDays,
  getDaysOfSolarYearToDate,
} from './solar'

export { getSolarMonthDays, HOUR_SELECTION, LUNAR_HOURS, STEMS, BRANCHES }

/**
 *
 *
 * @param year
 * @param monthIndex
 * 1月 => 0
 * 12月 & 無閏月 => 11
 * 12月 & 閏3月 => 12
 * @return
 */
const isBigMonth = (year, monthIndex) => {
  return (LUNAR_CONSTANTS[year - BASE_YEAR] & (0x80000 >> monthIndex)) !== 0
}

const getLeapMonth = year => {
  return LUNAR_CONSTANTS[year - BASE_YEAR] >> 20
}

const getDaysInLunarMonthByLeap = (year, month, isLeap) => {
  var m = month
  var lMonth = getLeapMonth(year)

  if (isLeap) {
    if (m !== lMonth) {
      //防呆
      return 0
    } else {
      //此為閏月需往計算之後一個月的天數
      return getDaysInLunarMonth(year, lMonth)
    }
  } else {
    if (lMonth > 0 && m > lMonth) {
      //若今年有閏月，且該西曆月應在閏月之後再加一個月
      m = m + 1
    }
    return getDaysInLunarMonth(year, m - 1)
  }
}

const getDaysOfLeapMonth = year => {
  let lm = getLeapMonth(year)
  return getDaysInLunarMonth(year, lm)
}

const getDaysOfLunarYearToDate = (lunarYear, lunarMonth, lunarDate, isLeap) => {
  var lMonth = getLeapMonth(lunarYear)

  // console.log("getDaysOfLunarYearToDate => leapMonth: "+ lMonth + ", isLeap: "+isLeap)
  var until = lunarMonth
  if (isLeap) until++

  var total = lunarDate
  var m = 1
  var offset = 0
  while (m < until) {
    if (lMonth !== 0 && m > lMonth) offset = 1
    else offset = 0
    // console.log("s: "+total)
    total += getDaysInLunarMonth(lunarYear, m - 1 + offset)
    m++
  }

  // console.log("leapMonth: "+lMonth +", total: "+ total)
  if (lMonth !== 0) {
    if (lunarMonth > lMonth) {
      return total + getDaysOfLeapMonth(lunarYear)
    } else {
      return total
    }
  } else if (isLeap) {
    return 0 //something is wrong
  } else {
    return total
  }
}

//  11010110101011100111101
//  10
/**
 *
 *
 * @param year
 * @param monthIndex
 * 1月 => 0
 * 12月 & 無閏月 => 11
 * 12月 & 閏3月 => 12
 * @return
 */
const getDaysInLunarMonth = (year, monthIndex) => {
  if (isBigMonth(year, monthIndex)) {
    return 30
  } else {
    return 29
  }
}

const getLunarDaysInMonth = (year, month) => {
  var t = 0
  if (month < 8) {
    t = 1
  }
  if (month % 2 === t) {
    return 31 //大月31天
  } else if (month === 2) {
    if (isLeapYear(year)) return 29
    else return 28 //閏年2月29天，非閏年2月28天
  } else {
    return 30 //小月30天
  }
}

const chineseNewYearOffset = year => {
  var lc = LUNAR_CONSTANTS[year - BASE_YEAR]
  var date = lc % 0x20
  var month = (lc >> 5) % 4

  // console.log("year: "+year+ ", lc: "+lc+", date: "+ date + ", month: "+month)
  var offset = date
  if (month > 1) offset = date + 31
  return offset - 1
}

const getYearStemIndex = (year: number) => {
  return (6 + (year - 1900)) % 10
}

const getYearBranchIndex = (year: number) => {
  return (year - 1900) % 12
}

export default class LunarDate {
  dayCyl: number
  monCyl: number
  // yearCyl: number
  year: number
  day: number
  hour: number
  lunarHour: number
  yearStem: number
  yearBranch: number
  isLeap: boolean
  month: number

  constructor(date: Date | LunarDate) {
    console.log('type of date: ', date)
    if (date.year && date.yearStem >= 0) {
      this.year = date.year
      this.month = date.month
      this.day = date.day
      this.hour = date.hour
      this.lunarHour = date.lunarHour
      this.yearStem = date.yearStem
      this.yearBranch = date.yearBranch
      this.isLeap = date.isLeap
    } else {
      date.setMilliseconds(0)
      let baseDate = new Date(BASE_YEAR, 0, 31)
      let offset = (date.getTime() - baseDate.getTime()) / 86400000

      this.dayCyl = offset + 40
      this.monCyl = 14

      var year = date.getFullYear()
      var lunarYear = this._calculateLunarYear(date)
      var lunarMonth = 0
      var lunarDate = 0
      var isLeap = false
      var dateDiff = getDaysOfSolarYearToDate(date)
      // console.log("dateDiff: "+dateDiff)
      var tempLeapMonth = getLeapMonth(year)
      var lMonth = tempLeapMonth

      var newYearDif = chineseNewYearOffset(year)

      if (dateDiff < newYearDif) {
        tempLeapMonth = getLeapMonth(year - 1)
        lMonth = tempLeapMonth

        dateDiff = newYearDif - dateDiff
        lunarMonth = 12

        // var cont = true
        while (true) {
          //  console.log("dateDiff: " + dateDiff + ", lunarMonth: " + lunarMonth)
          if (lMonth === lunarMonth) {
            let leapMonthDays = getDaysOfLeapMonth(year)
            if (dateDiff > leapMonthDays) {
              dateDiff = dateDiff - leapMonthDays
            } else {
              isLeap = true
            }
          }
          var lunarMonthDays = getDaysInLunarMonthByLeap(lunarYear, lunarMonth, false)
          if (dateDiff > lunarMonthDays) {
            dateDiff = dateDiff - lunarMonthDays
            isLeap = false
            lunarMonth = lunarMonth - 1
          } else {
            break
          }
        }

        if (dateDiff === 0) {
          lunarDate = 1
          lunarMonth = lunarMonth + 1
        } else {
          lunarDate =
            getDaysInLunarMonthByLeap(lunarYear, lunarMonth, isLeap) - dateDiff + 1
        }
      } else {
        var cnyo = chineseNewYearOffset(year)
        // console.log("_chineseNewYearOffset: "+cnyo)
        dateDiff = dateDiff - cnyo
        lunarMonth = 1

        // var cont = true
        while (true) {
          let lunarMonthDays = getDaysInLunarMonthByLeap(lunarYear, lunarMonth, false)

          //  console.log("lunarMonth: "+lunarMonth +", dateDiff: "+dateDiff+", lunarMonthDays: "+ lunarMonthDays)
          if (dateDiff >= lunarMonthDays) {
            dateDiff = dateDiff - lunarMonthDays
            if (lMonth === lunarMonth) {
              let leapMonthDays = getDaysOfLeapMonth(year)
              // console.log("leapMonthDays: "+ leapMonthDays)
              if (dateDiff >= leapMonthDays) {
                dateDiff = dateDiff - leapMonthDays
                lunarMonth++
              } else {
                isLeap = true
                break
              }
            } else {
              lunarMonth++
            }
          } else {
            break
          }
        }

        lunarDate = dateDiff + 1
      }

      // console.log("date.isLeap: "+this.isLeap + ", isLeap: "+ isLeap)
      this.year = lunarYear
      this.month = lunarMonth
      this.day = lunarDate
      this.hour = date.getHours()
      this.lunarHour = Math.ceil(this.hour / 2)
      this.isLeap = isLeap

      // console.log("lunarYear: "+lunarYear + ", lunarMonth: "+ lunarMonth + ", lunarDate: " + lunarDate + ", dateDiff: "+ dateDiff)
      // Year in chinese conposition of heavenly stem & earthly branch
      let rocYear = lunarYear - 1911
      this.yearStem = (rocYear + 7) % 10
      this.yearBranch = (rocYear + 11) % 12
    }
  }

  _calculateLunarYear(date: Date) {
    var year = date.getFullYear()
    var dateDiff = getDaysOfSolarYearToDate(date)
    var newYearDif = chineseNewYearOffset(year)
    if (dateDiff < newYearDif) {
      return year - 1
    } else {
      return year
    }
  }

  toWesternDate = () =>
    LunarDate.ToWesternDate(this.year, this.month, this.day, this.hour, this.isLeap)

  static ToWesternDate(
    year: number,
    month: number,
    day: number,
    hour: number,
    isLeap: boolean,
  ) {
    var cyear = 0
    var cmonth = 1
    var cdate = 0

    let lytd = getDaysOfLunarYearToDate(year, month, day, isLeap)

    //  console.log("lunarYear: "+ year + ", lunarMonth: " + month + ", lunarDate: "+ day + ", isLeap: "+ isLeap)
    let dateDiff = lytd - 1 + chineseNewYearOffset(year)
    let diy = getDaysInSolarYear(year)

    //  console.log("lytd: "+lytd+", chineseNewYearOffset: "+chineseNewYearOffset(year) + ", diy:" +diy)

    if (dateDiff >= diy) {
      dateDiff = dateDiff - diy
      cyear = year + 1
    } else {
      cyear = year
    }

    while (dateDiff >= getLunarDaysInMonth(cyear, cmonth)) {
      //  console.log("dateDiff: "+dateDiff + ", year: "+cyear+", month: "+cmonth+", daysInMonth: "+ getLunarDaysInMonth(cyear, cmonth))
      dateDiff = dateDiff - getLunarDaysInMonth(cyear, cmonth)
      cmonth++
    }

    cdate = dateDiff + 1

    return new Date(cyear, cmonth - 1, cdate, hour)
  }

  toString(i18n: Function) {
    // console.log('lunar date: ', this)
    if (!i18n) {
      return [this.year, this.month, this.day, this.lunarHour].join(' ')
    } else {
      return [
        i18n('lunar_date', {
          year:
            i18n(STEMS[getYearStemIndex(this.year)]) +
            i18n(BRANCHES[getYearBranchIndex(this.year)]) +
            '(' +
            this.year +
            ')',
          month: this.isLeap
            ? '(' + i18n('leap') + ')' + this.month
            : this.month,
          date: this.day,
          hour: i18n(LUNAR_HOURS[this.lunarHour].label),
        }),
      ]
    }
  }
}
